import ellipsisSvg from '@/assets/imgs/ellipsis.svg'
import logo from '@/assets/imgs/logo_head.png'
import spinnerSvg from '@/assets/imgs/spinner.svg'
import { GENERICS as dict } from '@/resources/dict'
import * as S from './styles'
import { LoadingProps } from './types'

const Loading = ({
  text = '',
  spinner = false,
  className = '',
}: LoadingProps) => {
  if (spinner) {
    return (
      <img
        className={className}
        src={spinnerSvg}
        alt="Spinner Loading"
        id="spinner-loading"
        data-testid="spinner-loading"
      />
    )
  }

  return (
    <S.Overlay data-testid="loading" className="global-loading">
      <S.Logo>
        <img src={logo} alt="Logo" />
      </S.Logo>
      <S.Text>{text || dict.loadingText.toUpperCase()}</S.Text>
      <div>
        <img
          src={ellipsisSvg}
          alt="Loading"
          id="page-loading"
          data-testid="page-loading"
        />
      </div>
    </S.Overlay>
  )
}

export default Loading
